import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { AssessmentLevelsService } from 'assessment/assessment-levels.service';
import { AssessmentInfoViewModel } from 'assessment/AssessmentInfoViewModel';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-assessment-badge',
  template: `
  <ng-container *ngIf="avm && type == 'badge'">
       <div class="badge"
       [ngClass]="classList"> {{avm.level}} - {{avm.description}} </div>
  </ng-container>
  <ng-container *ngIf="avm && type == 'avatar'">
    <div class="ab-list-group">
      <div class="ab-list-item pt-0050 pb-0050">
        <div class="d-flex flexWrap-nowrap flexJustify-start flexAlign-center">
          <span class="avatar avatar--sm avatar--a{{avm.color}}">
            <span class="avatar__assessment">{{avm.level}}</span>
          </span>
          <span class="ml-0075 txt-17 txt-fw-600">{{avm.description}}</span>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="avm && type == 'avatar-only'">
    <span class="avatar avatar--sm avatar--a{{avm.color}}">
      <span class="avatar__assessment">{{avm.level}}</span>
    </span>
  </ng-container>
   `
})
export class AssessmentBadgeComponent extends WithDisposableSubject() implements OnDestroy, OnChanges, OnInit {
  @Input() level: number;
  @Input() type?: string;
  @Input() size?: 'large';
  @Input() classes?: string;
  @Input() entityTypeId: string = null; // Handles description overrides when passed

  avm: AssessmentInfoViewModel;

  _changeSubject = new Subject<number>();

  get classList() {
    return [
      `badge--a${this.avm?.color}`,
       this.size ? `badge--${this.size}` : null,
       this.classes ? this.classes : null
    ].filter(d => d);
  }

  /**
   *
   */
  constructor(private assessmentLevelService: AssessmentLevelsService) {
    super();
  }

  ngOnInit() {
    if (!this.type) {
      console.error('AssessmentBadgeComponent: type [badge, avatar] is required');
    }

    this._changeSubject.pipe(
      takeUntil(this.disposer),
      startWith(this.level),
      distinctUntilChanged(),
      switchMap(level => this.assessmentLevelService.getAssessmentInfoVM(level, this.entityTypeId))
    ).subscribe((vm) => {
      this.avm = vm;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['level'];
    if (change) {
      this._changeSubject.next(change.currentValue);
    }
  }
}
